<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar class="page-header">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>Comments</span>
    </mat-toolbar>
    <!-- Main Body -->
    <div class="content-body">
      <div class="main-panel">
        <div class="content-wrapper">
          <!-- Page Title Header Starts-->
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="content-header">
                <p>Preview Comments for Signup: {{fullName}}</p>
                <mat-divider></mat-divider>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <mat-card>
                <!-- Add Comment -->
                <div class="col-lg-12 col-md-12 col-sm-12 comment-column">
                  <mat-label>Sign-up ID: {{applicantId}}</mat-label>
                  <p>
                    <mat-form-field appearance="outline" class="comment_date">
                      <mat-label>Date Updated</mat-label>
                      <input matInput [matDatepicker]="dp3" disabled>
                      <mat-hint>MM/DD/YYYY</mat-hint>
                      <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                      <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                    </mat-form-field>
                  </p>
                  <mat-form-field appearance="outline" color="accent" class="full-width">
                    <textarea rows="2" matInput placeholder="Write a comment" [(ngModel)]="comment"></textarea>
                  </mat-form-field>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 comment-button">
                  <button  mat-button (click)="addComments()">ADD NEW COMMENT</button>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table-striped">

                    <!--- 
                      Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" 
                    -->

                    <!-- ID -->
                    <ng-container matColumnDef="Id">
                      <th class="theadSign" mat-header-cell *matHeaderCellDef> ID. </th>
                      <td mat-cell *matCellDef="let element">{{element.id}}</td>
                    </ng-container>

                    <!-- Signup ID -->
                    <ng-container matColumnDef="SignupId">
                      <th class="theadSign" mat-header-cell *matHeaderCellDef> Signup ID. </th>
                      <td mat-cell *matCellDef="let element">{{element.signupId}}</td>
                    </ng-container>

                    <!-- Date -->
                    <ng-container matColumnDef="Date">
                      <th class="theadSign" mat-header-cell *matHeaderCellDef> Date </th>
                      <td mat-cell *matCellDef="let element"> {{element.date}} </td>
                    </ng-container>

                    <!-- Comment -->
                    <ng-container matColumnDef="Comment">
                      <th class="theadSign" mat-header-cell *matHeaderCellDef> Comments </th>
                      <td mat-cell *matCellDef="let element"> {{element.comment}} </td>
                    </ng-container>
                    <!-- Person ID -->
                    <ng-container matColumnDef="PersonId">
                      <th class="theadSign" mat-header-cell *matHeaderCellDef> Person ID. </th>
                      <td mat-cell *matCellDef="let element">{{element.personId}}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                </div>
                <mat-paginator #paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
              </mat-card>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12 download-comment">
              <a target="_self" rel="noopener noreferrer" class="ReportExport" (click)="downloadCommentsExcelFile()"
                >
                <img alt="Excel Logo" src="assets/img/comments.png">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>